import { z } from 'zod'

export const zHealth = z.object({
  status: z.enum(['ok', 'degraded']),
  time: z.string(),
})
export type Health = z.infer<typeof zHealth>

export const zHealthJobsInner = z.object({
  byStatus: z.record(z.number()),
  stuck: z.number(),
  scheduledDue: z.number(),
  queueDepth: z.number().nullable(),
})
export type HealthJobsInner = z.infer<typeof zHealthJobsInner>

export const zHealthJobs = z.object({
  jobs: zHealthJobsInner,
})
export type HealthJobs = z.infer<typeof zHealthJobs>
